import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import { removeCnpjMask, removeCpfMask } from '~/utils/funcoes'

const urlConsultaDiarias = '/service/contabilidade/ordemCronologicaPortal/'

class ConsultaOrdensPagamentosExtraorcamentariasService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio ? filtro.exercicio.value : null,
            dataOrdemInicial: filtro.dataOrdemInicial ? filtro.dataOrdemInicial : null,
            dataOrdemFinal: filtro.dataOrdemFinal ? filtro.dataOrdemFinal : null,
            dataPagamentoInicial: filtro.dataPagamentoInicial ? filtro.dataPagamentoInicial : null,
            dataPagamentoFinal: filtro.dataPagamentoFinal ? filtro.dataPagamentoFinal : null,
            situacao: filtro.situacao.value ? filtro.situacao.value : null,
            administracao: filtro.administracao && filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join(',') : this.state.adms,
            recurso: filtro.recurso && filtro.recurso.length > 0 ? filtro.recurso.map(e => `'${e.value}'`).join() : null,
            destinacao: filtro.destinacao && filtro.destinacao.length > 0 ? filtro.destinacao.map(e => `'${e.value}'`).join() : null,
            nomeCredor: filtro.nomeCredor ? filtro.nomeCredor : null,
            cnpj: filtro.cnpj ? removeCnpjMask(filtro.cnpj) : null,
            cpf: filtro.cpf ? removeCpfMask(filtro.cpf) : null,
        }

        return this.conex.post(urlConsultaDiarias + 'ordensPagamentosExtraorcamentarias/', JSON.stringify(data))
    }
}

export default ConsultaOrdensPagamentosExtraorcamentariasService
